import { AnimatePresence, motion } from 'framer-motion';
import { useEffect } from 'react';

const OrderSuccessModal = ({ order, onClose, onViewOrders }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onViewOrders) {
        onViewOrders();
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [onViewOrders]);

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 sm:p-8"
        >
          <div className="text-center">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4"
            >
              <svg
                className="h-8 w-8 text-[#008000]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </motion.div>

            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Order Placed Successfully!
            </h2>
            <p className="text-gray-600 mb-4">
              Your order has been confirmed and payment received.
            </p>

            {order && (
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <p className="text-sm text-gray-600 mb-1">Order Number</p>
                <p className="text-lg font-semibold text-gray-900">
                  {order.orderNumber}
                </p>
                <p className="text-sm text-gray-600 mt-2">
                  Total Amount: ₹{order.pricing?.total || order.totalAmount || 'N/A'}
                </p>
              </div>
            )}

            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={onViewOrders}
                className="flex-1 bg-[#008000] hover:bg-[#008000] text-white font-semibold py-3 px-6 rounded-lg transition-colors"
              >
                View My Orders
              </button>
              <button
                onClick={onClose}
                className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-3 px-6 rounded-lg transition-colors"
              >
                Close
              </button>
            </div>

            <p className="text-xs text-gray-500 mt-4">
              Redirecting to My Orders in 3 seconds...
            </p>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default OrderSuccessModal;

